export default "__VITE_ASSET__e8e593bf__"